var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeplinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.053,
    height: 52,
    viewBox: "0 0 65.053 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zeplin",
    transform: "translate(0 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19674",
    "data-name": "Path 19674",
    d: "M241.984,1326.4l-3.4,1.243-.181,10.123,11.78-4.3c-4.044-1.354-6.993-3.741-8.2-7.063",
    transform: "translate(-231.956 -1290.645)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19675",
    "data-name": "Path 19675",
    d: "M11.809,930.3,0,934.614l6.625,7.639,3.4-1.243c-1.2-3.311-.46-7.049,1.781-10.709",
    transform: "translate(0 -905.252)",
    fill: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19676",
    "data-name": "Path 19676",
    d: "M372.093,284.017c-15.037,5.492-24.732,16.829-21.651,25.316l54.452-19.891c-3.081-8.487-17.764-10.917-32.8-5.425",
    transform: "translate(-340.414 -273.578)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19677",
    "data-name": "Path 19677",
    d: "M403.7,615.916c15.037-5.492,24.749-16.777,21.651-25.316L370.9,610.489c3.1,8.541,17.764,10.92,32.8,5.428",
    transform: "translate(-360.875 -574.734)",
    fill: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19678",
    "data-name": "Path 19678",
    d: "M425.449,590.5,371,610.391c1.065,2.941,5.133,4.39,10.836,4.39,5.563,0,12.682-1.376,20.1-4.087,15.037-5.492,25.613-14.388,23.508-20.194",
    transform: "translate(-360.972 -574.636)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19679",
    "data-name": "Path 19679",
    d: "M405,428.2c-5.56,0-12.682,1.376-20.1,4.087-15.037,5.492-25.613,14.385-23.508,20.191l54.452-19.891C414.769,429.646,410.7,428.2,405,428.2",
    transform: "translate(-351.357 -416.723)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15770",
    "data-name": "Group 15770",
    transform: "translate(21.057 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19680",
    "data-name": "Path 19680",
    d: "M808.613,202.824c-1.6,0-3.965-1.446-7.025-4.3A90.847,90.847,0,0,1,789.913,184.6a90.939,90.939,0,0,1-9.044-15.775c-2.095-4.979-2.395-8.039-.889-9.1a2.007,2.007,0,0,1,1.184-.349c1.224,0,3.614.911,8.028,5.257l.1.095-.014.135c-.03.314-.057.627-.081.938l-.049.614-.432-.435c-4.757-4.792-6.849-5.309-7.53-5.309a.787.787,0,0,0-.46.116c-.654.46-.7,2.708,1.335,7.533a89.686,89.686,0,0,0,8.912,15.534,89.307,89.307,0,0,0,11.5,13.72c3.833,3.576,5.56,3.963,6.125,3.963a.8.8,0,0,0,.47-.124c.689-.484.689-2.892-1.576-8.087l-.105-.238.227-.124c.227-.124.449-.246.654-.365l.273-.154.127.287c1.606,3.681,3.108,8.36,1.138,9.744A2.019,2.019,0,0,1,808.613,202.824Zm0-.568v0Z",
    transform: "translate(-779.037 -155.065)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19681",
    "data-name": "Path 19681",
    d: "M1138.193,41.026l-.022.281c-.381,4.7-1.381,10.358-3.992,10.588-.054.005-.108.005-.159.005-1.773,0-3.452-2.541-4.984-7.549a90.849,90.849,0,0,1-3.173-17.918,91.052,91.052,0,0,1,.024-18.2c.665-5.363,1.93-8.163,3.763-8.325.054-.005.111-.008.165-.008,1.287,0,3.225,1.457,5.209,8.241l-1.295.249a26.672,26.672,0,0,0-2.1-5.379c-.662-1.17-1.308-1.816-1.814-1.816a.344.344,0,0,0-.051,0c-.795.07-1.952,1.995-2.595,7.2a89.758,89.758,0,0,0-.021,17.926,89.736,89.736,0,0,0,3.122,17.65,24.057,24.057,0,0,0,2.027,4.968c.632,1.076,1.246,1.668,1.724,1.668a.3.3,0,0,0,.049,0c.76-.065,2.192-2.07,2.795-9.123Z",
    transform: "translate(-1116.059 0.1)",
    fill: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeplinLogo);
export default __webpack_public_path__ + "static/media/zeplin-logo.9adc2ea5edfc8f762ca0fdaadd6bf291.svg";
export { ForwardRef as ReactComponent };